import React from "react";
import { Tooltip, Typography, Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const ImageResolutionTooltip = ({ label = "Upload Guidelines", data, position, style }) => {
  if (!data || !Array.isArray(data)) return null;

  const thStyle = {
    border: "1px solid #ccc",
    padding: "4px 8px",
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    textTransform: "capitalize",
  };

  const tdStyle = {
    border: "1px solid #ccc",
    padding: "4px 8px",
    whiteSpace: "nowrap",
  };

  const headers = Object.keys(data?.length?data[0]:[]);

  const tooltipContent = (
    <Box sx={{ p: 1 }}>
      <table style={{ borderCollapse: "collapse", fontSize: "13px", width: "100%" }}>
        <thead>
          <tr>
            {headers.map((head, i) => (
              <th key={i} style={thStyle}>
                {head}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              <td style={tdStyle}>{row.name}</td>
              <td style={tdStyle}>{row.files}</td>
              <td style={tdStyle}>{row.size}</td>
              {row.height && <td style={tdStyle}>{row.height}</td>}
              {row.width && <td style={tdStyle}>{row.width}</td>}
              {row.resolution && <td style={tdStyle}>{row.resolution}</td>}
              {row.aspect && <td style={tdStyle}>{row.aspect}</td>}
              <td style={tdStyle}>{row.formats}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement={position}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "white",
            color: "black",
            maxWidth: "none",
            overflow: "auto",
            boxShadow: 3,
            border: "1px solid #ccc",
          },
        },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          textDecoration: "underline",
          cursor: "pointer",
          display: "inline-block",
        }}
      >
        <FontAwesomeIcon style={style} icon={faCircleInfo} />
      </Typography>
    </Tooltip>
  );
};

export default ImageResolutionTooltip;
